<template>
  <div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalDate"
    aria-hidden="true"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Modifier les dates</h5>
          <button
            v-on:click="unblock()"
            ref="closeModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-5 text-right pt-2">
              <label for="date-1">Date 1 :</label>
            </div>
            <div class="col-7 text-right">
              <input v-model="estimate.date1" id="date-1" type="date" class="form-control mb-3">
            </div>
            <div class="col-5 text-right pt-2">
              <label for="ratio-date-1">1er versement :</label>
            </div>
            <div class="col-7 text-right mb-3">
              <div class="input-group mb-3">
                <input
                  id="ratio-date-1"
                  v-model="estimate.ratio_date1"
                  v-on:input="limitPercent('ratio_date1')"
                  type="number"
                  class="form-control"
                  min="0"
                  max="100"
                >
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>

            <div class="col-5 text-right pt-2">
              <label for="date-2">Date 2 :</label>
            </div>
            <div class="col-7 text-right">
              <input v-model="estimate.date2" id="date-2" type="date" class="form-control mb-3">
            </div>
            <div class="col-5 text-right pt-2">
              <label for="ratio-date-2">2ème versement :</label>
            </div>
            <div class="col-7 text-right mb-3">
              <div class="input-group mb-3">
                <input
                  id="ratio-date-2"
                  v-model="estimate.ratio_date2"
                  v-on:input="limitPercent('ratio_date2')"
                  type="number"
                  class="form-control"
                  min="0"
                  max="100"
                >
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>

            <div class="col-5 text-right pt-2">
              <label for="date-3">Date 3 :</label>
            </div>
            <div class="col-7 text-right">
              <input v-model="estimate.date3" id="date-3" type="date" class="form-control mb-3">
            </div>
            <div class="col-5 text-right pt-2">
              <label for="ratio-date-3">3ème versement :</label>
            </div>
            <div class="col-7 text-right mb-3">
              <div class="input-group mb-3">
                <input
                  id="ratio-date-3"
                  v-model="estimate.ratio_date3"
                  v-on:input="limitPercent('ratio_date3')"
                  type="number"
                  class="form-control"
                  min="0"
                  max="100"
                >
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-on:click="updateDates()" type="button" class="btn btn-primary">Sauvegarder</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    estimate: Object
  },
  methods: {
    limitPercent: function(key) {
      if (this.estimate[key] < 0 || this.estimate[key] == "")
        this.estimate[key] = 0;
      if (this.estimate[key] > 100) this.estimate[key] = 100;
      if (this.estimate[key].toString().startsWith("0"))
        this.estimate[key] = Number(
          this.estimate[key].toString().split("0")[1]
        );
    },
    unblock() {
      this.estimate.blocked = false;
    },
    updateDates() {
      this.$parent.updateEstimate(this.estimate, updatedEstimate => {
        this.estimate.date1 = updatedEstimate.date1;
        this.estimate.ratio_date1 = updatedEstimate.ratio_date1;
        this.estimate.date2 = updatedEstimate.date2;
        this.estimate.ratio_date2 = updatedEstimate.ratio_date2;
        this.estimate.date3 = updatedEstimate.date3;
        this.estimate.ratio_date3 = updatedEstimate.ratio_date3;

        this.unblock();

        this.$refs.closeModal.click();
      });
    }
  }
};
</script>
<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

